import { useQuery } from "@tanstack/react-query";
import { Download } from "lucide-react";
import { Reveal, Eyebrow, Button } from "../components/primitives";
import { Seo } from "../components/Seo";
import { api, API } from "../lib/api";

export default function Constitution() {
  const { data } = useQuery({
    queryKey: ["constitution"],
    queryFn: async () => (await api.get("/constitution")).data,
  });
  const articles = data?.articles || [];

  return (
    <>
      <Seo title="The Constitution" description="Glam Wagon operates according to an internal constitution — the binding principles that govern how we serve clients, teammates and communities." />
      <section className="pt-40 pb-16 max-w-4xl mx-auto px-6 lg:px-12 text-center" data-testid="constitution-hero">
        <Reveal>
          <div className="flex justify-center"><Eyebrow>{data?.subtitle || "The principles we are bound by"}</Eyebrow></div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-[4.5rem] leading-[1] tracking-tight mt-6 text-ink">
            {data?.title || "The Glam Wagon Constitution"}
          </h1>
          <p className="mt-8 text-lg leading-relaxed text-ink-soft">{data?.preamble}</p>
          <Button
            as="a"
            href={`${API}/constitution/pdf`}
            data-testid="download-constitution-btn"
            className="mt-10"
          >
            <Download size={16} /> Download as PDF
          </Button>
        </Reveal>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-12 pb-28">
        <div className="border-t border-line" data-testid="constitution-articles">
          {articles.map((art, i) => (
            <Reveal key={art.title} delay={0.05}>
              <article className="py-10 border-b border-line">
                <h2 className="font-serif text-2xl sm:text-3xl text-ink">{art.title}</h2>
                <p className="mt-4 text-lg leading-relaxed text-ink-soft">{art.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
